import {NgModule} from '@angular/core';
import {RouterModule, Routes} from '@angular/router';
import {ConsultarProcesosComponent} from './views/consultar-procesos/consultar-procesos.component';
import {EjecutarProcesosComponent} from './views/ejecutar-procesos/ejecutar-procesos.component';
import { ConfigurarCpdComponent } from './views/configurar-cpd/configurar-cpd.component';

const garitasRoutes: Routes = [
  { path: 'rplus/consultar-procesos', component: ConsultarProcesosComponent,  /* canActivate: [AuthGuard] */},
  { path: 'rplus/ejecutar-procesos',  component: EjecutarProcesosComponent, /* canActivate: [AuthGuard] */  },
  { path: 'rplus/configurar-cpd',     component: ConfigurarCpdComponent, /* canActivate: [AuthGuard] */     }, //T.14473 CPD Forzado
];

@NgModule({
  imports: [RouterModule.forChild(garitasRoutes)],
  exports: [RouterModule]
})
export class RPlusRoutingModule {
}
